export default "__VITE_ASSET__BCPTwchj__"